var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yn-modal',[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Annotation Log")]),(Array.isArray(_vm.item.audit) && _vm.item.audit.length > 0)?_c('yn-list',{attrs:{"name":"audit","data":_vm.item.audit,"total":_vm.item.audit.length,"skip":0,"size":_vm.item.audit.length,"metadata":{
      by: {
        label: 'By',
        width: '1fr'
      },

      label: {
        label: 'Label',
        width: '75px'
      }
    },"actions":[],"is-request-pending":false,"is-request-failed":false},scopedSlots:_vm._u([{key:"label",fn:function(ref){
    var item = ref.item;
return [(item.complaint && item.complaint.length)?_c('i',{staticClass:"task-report"},[_vm._v(" ⚑ ")]):_c('span',[_vm._v(_vm._s(!!item.label))])]}}],null,false,2635354614)}):_c('div',[_vm._v(" This item was not labeld yet. ")]),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('yn-button',{attrs:{"type":"text","color":"secondary"},on:{"click":_vm.close}},[_vm._v("Close")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }